<template>
  <div v-if="!loading">
    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>

    <transition name="modal">
      <local-delivery-range-modal
        v-if="showRangeForm"
        :range="rangeToModify"
        :branch="branch"
        :loading="loadingDelete"
        @close="
          showRangeForm = false;
          rangeToModify = null;
        "
        @updateRanges="
          showRangeForm = false;
          rangeToModify = null;
          loadBranch();
        "
      ></local-delivery-range-modal>
    </transition>

    <h2>Rangos de envío</h2>

    <div v-if="branch">
      <button
        v-if="hasPermission('edit_ranges')"
        class="secondary-button block mt-2"
        @click.prevent="showRangeForm = true"
      >
        + Crear Rango
      </button>

      <div
        v-for="(range, index) in branch.local_delivery_ranges"
        :key="range.id"
        class="card mt-4 text-sm"
      >
        <div>
          <p class="font-medium mt-2">
            De {{ range.min > 0 ? "más de " : "" }}
          </p>
          <p>{{ range.min }} km</p>
        </div>

        <div>
          <p class="font-medium mt-2">A</p>
          <p>{{ range.max }} km</p>
        </div>

        <div>
          <p class="font-medium mt-2">Precio</p>
          <p>{{ integerToCurrency(range.price) }}</p>
        </div>

        <div class="flex space-x-2 mt-4 items-center">
          <edit-button
            @click="
              rangeToModify = range;
              showRangeForm = true;
            "
          >
          </edit-button>

          <delete-button
            v-if="index === branch.local_delivery_ranges.length - 1"
            @click="
              rangeToModify = range;
              openDeleteModal();
            "
          >
          </delete-button>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="flex w-full h-full items-center">
    <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
  </div>
</template>

<script>
import LocalDeliveryRangeModal from "@/components/modals/LocalDeliveryRangeModal";
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import validationErrors from "@/mixins/validationErrors";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Local Delivery Ranges",

  components: {
    LocalDeliveryRangeModal,
  },

  data() {
    return {
      branch: null,
      loading: false,
      showRangeForm: false,
      rangeToModify: null,
    };
  },

  mixins: [deleteMixin, validationErrors],

  computed: {
    minValue() {
      if (!this.branch || this.branch.local_delivery_ranges.length === 0) {
        return 0;
      }

      return this.branch.local_delivery_ranges[
        this.branch.local_delivery_ranges.length - 1
      ].max;
    },
  },

  created() {
    this.$store.commit("setSelectedTab", "ranges");

    this.loadBranch();
  },

  methods: {
    integerToCurrency,

    async loadBranch() {
      this.loading = true;

      try {
        this.branch = await api.branches.getById(this.$route.params.branchId);
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: "" });
      }

      this.loading = false;
    },

    closeRangeForm() {
      this.showRangeForm = false;
      this.max = "";
      this.price = "";
    },

    validateForm() {
      this.errors = {};

      if (this.max === "") {
        this.errors["max"] = ["Campo requerido"];
      }

      if (this.max > this.branch.max_distance) {
        this.errors["max"] = [
          "La distancia no puede superar el límite de envío de la sucursal",
        ];
      }

      if (this.price === "") {
        this.errors["price"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async deleteElement() {
      this.loadingDelete = true;

      if (this.rangeToModify) {
        try {
          const response = await api.ranges.delete(this.rangeToModify.id);
          this.$store.dispatch("successSnack", response.message);
          this.closeDeleteModal();
          this.rangeToModify = null;
          this.loadBranch();
        } catch (error) {
          this.$store.dispatch("errorSnack", error?.response?.data?.message);
        }
      }

      this.loadingDelete = false;
    },
  },
};
</script>